import React from "react";
import { twMerge } from "tailwind-merge";

export default function FormLabel({
  label,
  className,
}: {
  label: string;
  className?: string;
}) {
  return (
    <label
      className={twMerge(
        "block text-xs font-medium text-gray-700 dark:text-gray-300",
        className,
      )}
    >
      {label}
    </label>
  );
}
